import React from "react";
import { AuthProvider } from "./contexts/AuthContexts";
import { UserProvider } from "./contexts/UserContexts";
import { GlobalProvider } from "./contexts/GlobalContext";
import { SignUp } from "./pages/SignUp";
import { Profile } from "./pages/Profile";
import { Login } from "./pages/Login";
import { LandingPage } from "./pages/LandingPage";
import { ForgotPassword } from "./pages/ForgotPassword";
import { UpdateProfile } from "./pages/UpdateProfile";
import { Track } from "./pages/Track";
import { Home } from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { GlobalStyle } from "./styles/global";
import { Special } from "./pages/Special";

function App() {
  return (
    <>
      <GlobalStyle/>
      <Router>
        <AuthProvider>
          <UserProvider>
            <GlobalProvider>
              <Routes>
                <Route exact path="/" element={ <LandingPage/> } />
                <Route path="/profile" element={ <PrivateRoute><Profile/></PrivateRoute> } />
                <Route path="/update-profile" element={ <PrivateRoute><UpdateProfile/></PrivateRoute> } />
                <Route path="/track" element={ <PrivateRoute><Track/></PrivateRoute> } />
                <Route path="/special" element={ <PrivateRoute><Special/></PrivateRoute> } />
                <Route path="/home" element={ <PrivateRoute><Home/></PrivateRoute> } />
                <Route path="/signup" element={ <SignUp/> } />
                <Route path="/login" element={ <Login/> } />
                <Route path="/forgot-password" element={<ForgotPassword/>}></Route>
              </Routes>
            </GlobalProvider>
          </UserProvider>
        </AuthProvider>
      </Router>
    </>
  )
};

export default App;
